import Timesheets from "./views/timesheets";
import Employees from "./views/employees";
import Placements from "./views/placements";
import History from "./views/history";
import Clients from "./views/clients";
import DataSavvy from "./views/datasavvy";
import ClientTimesheets from "./views/clienttimesheets";
import ClientHistory from "./views/clienthistory";

const routes = [
  {
    path: "/handler",
    exact: true,
    name: "Home",
  },

  {
    path: "/handler/placements",
    name: "Placements",
    component: Placements,
    exact: true,
  },

  {
    path: "/handler/timesheets",
    name: "Timesheets",
    component: Timesheets,
    exact: true,
  },

  {
    path: "/handler/history",
    name: "History",
    component: History,
    exact: true,
  },
  {
    path: "/handler/employees",
    name: "Employees",
    component: Employees,
    exact: true,
  },
  {
    path: "/handler/clients",
    name: "Clients",
    component: Clients,
    exact: true,
  },
  {
    path: "/handler/datasavvy",
    name: "DataSavvy",
    component: DataSavvy,
    exact: true,
  },
  {
    path: "/clientpage",
    exact: true,
    name: "Client Home",
  },

  {
    path: "/clientpage/clienttimesheets",
    name: "Client Timesheets",
    component: ClientTimesheets,
    exact: true,
  },
  {
    path: "/clientpage/clientHistory",
    name: "Client History",
    component: ClientHistory,
    exact: true,
  },
];

export default routes;
